exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.noHit {\n  text-align:center;\n  margin:4ex;\n  font-size:200%;\n  font-weight:bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages-box/pages-box.component.css
// module id = 393
// module chunks = 0